import {get} from './api-service';

const routes = {
  base: 'events',
  types: 'events/types',
}

export const getEvents = async (filters = '') => {
  return await get(`${routes.base}?page=1${filters}`);
}

export const getEventTypes = async () => {
  return await get(routes.types);
}
